/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Listen_Go_CommuteInputs */

const en_onboarding_listen_go_commute = /** @type {(inputs: Onboarding_Listen_Go_CommuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On my commute`)
};

const es_onboarding_listen_go_commute = /** @type {(inputs: Onboarding_Listen_Go_CommuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En mi trayecto`)
};

/**
* | output |
* | --- |
* | "On my commute" |
*
* @param {Onboarding_Listen_Go_CommuteInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_listen_go_commute = /** @type {((inputs?: Onboarding_Listen_Go_CommuteInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Listen_Go_CommuteInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_listen_go_commute(inputs)
	return en_onboarding_listen_go_commute(inputs)
});